"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgAtSign = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M27.5 13.288A11 11 0 0136 24v1a4 4 0 01-7.26 2.318 5 5 0 111.255-3.535L30 24v1a2 2 0 104 0v-1a9 9 0 10-3.528 7.146 1 1 0 111.216 1.588A11 11 0 1127.5 13.288zM25 21a3 3 0 100 6 3 3 0 000-6z",
    id: "at-sign_svg__a"
  }));
};

var _default = SvgAtSign;
exports.default = _default;